import { useState } from "react";

const BasicModal = ({
    title,
    body,
    openModalButtonText,
    openModalButtonClasses,
    mainButtonClasses,
    openModalClasses,
    mainButtonText,
    mainButtonAction,
    footer = true
}) => {
    const [show, setShow] = useState(false)

    return (
        <>
            <button
                type="button"
                className={openModalButtonClasses}
                data-bs-toggle="modal"
                data-bs-target="#kt_modal_1"
                onClick={() => setShow(true)}
            >
                {openModalButtonText}
            </button>

            <div className={"modal fade " + openModalClasses + (show ? " show" : "")} tabIndex="-1" id="kt_modal_1" style={{ display: (show ? 'block' : 'none') }}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{title}</h5>

                            <div className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => setShow(false)}
                            >
                                <i className="fas fa-times fs-1"></i>
                            </div>
                        </div>

                        <div className="modal-body">
                            {body}
                        </div>

                        { footer && (<div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light"
                                data-bs-dismiss="modal"
                                onClick={() => setShow(false)}
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className={mainButtonClasses}
                                onClick={() => { mainButtonAction(); setShow(false) }}
                            >
                                {mainButtonText}
                            </button>
                        </div>)}
                    </div>
                </div>
            </div>
        </>
    )
}

export default BasicModal;